import React from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { withBreakpoints } from "react-breakpoints"

import Close from "../svg/Close"
import Arrow from "../svg/Arrow"

import { isMobile } from "../utils/breakpoints"

class ContentFilterContent extends React.Component {
  isActive() {
    return this.props.selected === this.props.prefix ? true : false
  }

  activeClassName() {
    return this.isActive() ? `is-selected` : ``
  }

  render() {
    return (
      <ul
        ref="group"
        className={`content__filters__group__content is-unstyled ${this.activeClassName()}`}
      >
        {this.props.list.map((item, index) => (
          <li key={index}>
            <Link
              to={`${this.props.rootURL}${this.props.prefix}/${item.node.slug}`}
              activeClassName="is-active"
            >
              {item.node[this.props.objectName]}
            </Link>
          </li>
        ))}
      </ul>
    )
  }
}

ContentFilterContent.defaultProps = {
  rootURL: `/work/`,
}

class ContentFilters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      minHeight: `0px`,
      isOpen: false,
    }
    // register events
    this.setSelectedPrefix = this.setSelectedPrefix.bind(this)
    this.toggleVisibility = this.toggleVisibility.bind(this)
  }

  setSelectedPrefix(e, prefix = null) {
    this.setState({
      selected: prefix,
      minHeight: isMobile(this.props.currentBreakpoint, `tablet`)
        ? `auto`
        : this.calculateHeight(prefix),
    })

    // only go back to ROOT_URL when pathname is not ROOT_URL
    if (window.location.pathname === this.props.rootURL || prefix !== null) {
      e.preventDefault()
    }
  }

  toggleVisibility(e) {
    e.preventDefault()
    let isOpen = !this.state.isOpen
    this.setState({
      isOpen: isOpen,
    })
  }

  calculateHeight(prefix = null) {
    let group = this.refs[prefix]
    if (group !== undefined) {
      return `${ReactDOM.findDOMNode(this.refs[prefix].refs.group)
        .offsetHeight + 60}px`
    } else {
      return `0px`
    }
  }

  heightStyle() {
    return {
      minHeight: `${this.state.minHeight}`,
    }
  }

  activeClassName(prefix) {
    return this.state.selected === prefix ? `is-active` : ``
  }

  hasSelectionClassName() {
    return this.state.selected ? `has-selection` : ``
  }

  visibilityClassName() {
    let isDesktop = !isMobile(this.props.currentBreakpoint, `tablet`)
    return isDesktop || this.state.isOpen ? `is-open` : `is-closed`
  }

  // ***
  // Remove filter items with empty list from current indexType
  // ie: if work/brand/toyota is empty, this will discard the filter to appear the navigation
  // ***
  stripList(filterList, lengthOnly = false) {
    let list = []
    filterList.forEach(item => {
      let childrens = item.node[this.props.indexType]
      if (childrens) list.push(item)
    })
    return !lengthOnly ? list : list.length
  }

  render() {
    return (
      <nav
        className={`content__filters ${this.hasSelectionClassName()} ${this.visibilityClassName()}`}
        style={this.style}
      >
        <div className="d-sm-none">
          <a
            href="#"
            className="btn__arrow"
            onClick={e => this.toggleVisibility(e)}
          >
            {!this.state.isOpen && <span>Show filters</span>}
            {this.state.isOpen && <span>Hide filters</span>}
            <Arrow direction={this.state.isOpen ? `top` : `bottom`} />
          </a>
        </div>
        <div className={`content__filters__inner`} style={this.heightStyle()}>
          <ul className="is-unstyled content__filters__groups">
            <li
              className={`content__filters__group ${this.activeClassName(
                null
              )}`}
            >
              <Link
                to={`${this.props.rootURL}`}
                activeClassName="is-active"
                exact
                tabIndex="-1"
                onClick={e => this.setSelectedPrefix(e, null)}
              >
                All
              </Link>
            </li>

            {this.props.offices && (
              <li
                className={`content__filters__group ${this.activeClassName(
                  `office`
                )}`}
              >
                <Link
                  to={`${this.props.rootURL}office/`}
                  activeClassName="is-active"
                  className={this.activeClassName(`office`)}
                  onClick={e => this.setSelectedPrefix(e, `office`)}
                >
                  Office
                  {` `}
                  <sup>{this.stripList(this.props.offices.edges, true)}</sup>
                </Link>
                <ContentFilterContent
                  ref="office"
                  list={this.stripList(this.props.offices.edges)}
                  rootURL={this.props.rootURL}
                  prefix="office"
                  objectName="officeName"
                  selected={this.state.selected}
                />
              </li>
            )}

            {this.props.brands && (
              <li
                className={`
                  content__filters__group
                  ${this.activeClassName(`brand`)}
                `}
              >
                <Link
                  to={`${this.props.rootURL}brand/`}
                  activeClassName="is-active"
                  className={this.activeClassName(`brand`)}
                  onClick={e => this.setSelectedPrefix(e, `brand`)}
                >
                  Client
                  {` `}
                  <sup>{this.stripList(this.props.brands.edges, true)}</sup>
                </Link>
                <ContentFilterContent
                  ref="brand"
                  list={this.stripList(this.props.brands.edges)}
                  rootURL={this.props.rootURL}
                  prefix="brand"
                  objectName="brandName"
                  selected={this.state.selected}
                />
              </li>
            )}

            {this.props.workCategories && (
              <li
                className={`content__filters__group d-none${this.activeClassName(
                  `category`
                )}`}
              >
                <Link
                  to={`${this.props.rootURL}category/`}
                  activeClassName="is-active"
                  className={this.activeClassName(`category`)}
                  onClick={e => this.setSelectedPrefix(e, `category`)}
                >
                  Category
                  {` `}
                  <sup>
                    {this.stripList(this.props.workCategories.edges, true)}
                  </sup>
                </Link>
                <ContentFilterContent
                  ref="category"
                  list={this.stripList(this.props.workCategories.edges)}
                  rootURL={this.props.rootURL}
                  prefix="category"
                  objectName="name"
                  selected={this.state.selected}
                />
              </li>
            )}

            {this.props.classics && (
              <li className={`content__filters__group d-none`}>
                <Link
                  exact
                  to={`${this.props.rootURL}classics/`}
                  activeClassName="is-active"
                >
                  Classics <sup>{this.props.workCategories.edges.length}</sup>
                </Link>
              </li>
            )}

            {this.props.workDesign && (
              <li className={`content__filters__group d-none`}>
                <Link
                  exact
                  to={`${this.props.rootURL}design/`}
                  activeClassName="is-active"
                >
                  Design <sup>{this.props.workCategories.edges.length}</sup>
                </Link>
              </li>
            )}

            <li className="no-padding no-margin d-none d-md-inline-block">
              <Link
                to={`${this.props.rootURL}`}
                className={`content__filters__close btn__close`}
                onClick={e => this.setSelectedPrefix(e, null)}
              >
                <Close color="#495057" />
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

ContentFilters.defaultProps = {
  rootURL: `/work/`,
  defaultType: null,
  indexType: `work`,
}

ContentFilters.propTypes = {
  rootURL: PropTypes.string.isRequired,
  indexType: PropTypes.string.isRequired,
  defaultType: PropTypes.string,
  offices: PropTypes.object,
  brands: PropTypes.object,
  workCategories: PropTypes.object,
  classics: PropTypes.bool,
  workDesign: PropTypes.bool,
}

export default withBreakpoints(ContentFilters)
